'use client'

import { useEffect } from 'react'
import { usePageCSSClass } from './PageCSSClassContext'

export function PageCSSClassSetter({ className }: { className?: string }) {
  const { setPageClass } = usePageCSSClass()

  useEffect(() => {
    if (className) setPageClass(className)
    return () => setPageClass('')
  }, [className, setPageClass])

  return null
}
